(() => {
  const normalize = (value) => String(value || '')
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  document.querySelectorAll('[data-lp-library]').forEach((library) => {
    if (library.dataset.ready === 'true') return;
    library.dataset.ready = 'true';

    const search = library.querySelector('[data-lp-library-search]');
    const grid = library.querySelector('[data-lp-library-grid]');
    const cards = [...library.querySelectorAll('[data-lp-library-card]')];
    const count = library.querySelector('[data-lp-library-count]');
    const empty = library.querySelector('[data-lp-library-empty]');
    const pagination = library.querySelector('[data-lp-library-pagination]');
    const pageList = library.querySelector('[data-lp-pagination-pages]');
    const pageSummary = library.querySelector('[data-lp-pagination-summary]');
    const previousPage = library.querySelector('[data-lp-pagination-prev]');
    const nextPage = library.querySelector('[data-lp-pagination-next]');
    const letterButtons = [...library.querySelectorAll('[data-lp-letter]')];
    const topicButtons = [...library.querySelectorAll('[data-lp-topic]')];
    let activeLetter = 'all';
    let activeTopic = 'all';
    let currentPage = 1;
    let currentColumns = 0;

    const columnCount = () => {
      if (!grid) return 1;
      const columns = window.getComputedStyle(grid).gridTemplateColumns
        .split(' ')
        .filter(Boolean).length;
      return Math.max(1, columns || 1);
    };

    const compactPages = (totalPages) => {
      if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);

      const items = [1];
      const firstMiddle = Math.max(2, currentPage - 1);
      const lastMiddle = Math.min(totalPages - 1, currentPage + 1);
      if (firstMiddle > 2) items.push('start-gap');
      for (let page = firstMiddle; page <= lastMiddle; page += 1) items.push(page);
      if (lastMiddle < totalPages - 1) items.push('end-gap');
      items.push(totalPages);
      return items;
    };

    const renderPagination = (totalItems, pageSize) => {
      if (!pagination || !pageList) return;
      const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
      currentPage = Math.min(currentPage, totalPages);
      pagination.hidden = totalItems === 0 || totalPages <= 1;
      previousPage.disabled = currentPage <= 1;
      nextPage.disabled = currentPage >= totalPages;
      pageSummary.textContent = `${currentPage} / ${totalPages}`;
      pageList.replaceChildren();

      compactPages(totalPages).forEach((item) => {
        if (typeof item !== 'number') {
          const gap = document.createElement('span');
          gap.className = 'lp-library__page-gap';
          gap.textContent = '…';
          gap.setAttribute('aria-hidden', 'true');
          pageList.append(gap);
          return;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lp-library__page-number';
        button.textContent = String(item);
        button.setAttribute('aria-label', `Page ${item}`);
        if (item === currentPage) button.setAttribute('aria-current', 'page');
        button.addEventListener('click', () => {
          currentPage = item;
          refresh();
          library.querySelector('.lp-library__tools')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pageList.append(button);
      });
    };

    const refresh = () => {
      const query = normalize(search?.value);
      const matches = cards.filter((card) => {
        const textMatch = !query || normalize(`${card.dataset.title} ${card.dataset.excerpt}`).includes(query);
        const letterMatch = activeLetter === 'all' || normalize(card.dataset.letter) === normalize(activeLetter);
        const topics = String(card.dataset.topics || '').split(/\s+/);
        const topicMatch = activeTopic === 'all' || topics.includes(activeTopic);
        return textMatch && letterMatch && topicMatch;
      });
      const columns = columnCount();
      const pageSize = columns * 4;
      const totalPages = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.min(currentPage, totalPages);
      const firstItem = (currentPage - 1) * pageSize;
      const visibleCards = new Set(matches.slice(firstItem, firstItem + pageSize));

      cards.forEach((card) => {
        const show = visibleCards.has(card);
        card.hidden = !show;
        card.classList.toggle('is-page-visible', show);
      });

      if (count) count.textContent = String(matches.length);
      if (empty) empty.hidden = matches.length !== 0;
      renderPagination(matches.length, pageSize);
    };

    search?.addEventListener('input', () => {
      currentPage = 1;
      refresh();
    });

    previousPage?.addEventListener('click', () => {
      if (currentPage <= 1) return;
      currentPage -= 1;
      refresh();
    });

    nextPage?.addEventListener('click', () => {
      currentPage += 1;
      refresh();
    });

    letterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeLetter = button.dataset.lpLetter || 'all';
        currentPage = 1;
        letterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        refresh();
      });
    });

    topicButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeTopic = button.dataset.lpTopic || 'all';
        currentPage = 1;
        topicButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        refresh();
      });
    });

    currentColumns = columnCount();
    refresh();

    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => {
        const columns = columnCount();
        if (columns === currentColumns) return;
        currentColumns = columns;
        currentPage = 1;
        refresh();
      });
    }, { passive: true });
  });
})();
